import cx from 'classnames'
import { SEARCH_TYPE_ICONS } from 'constants/search-icons'
import { styled } from '@mui/material/styles'
import MuiButton from '@mui/material/Button'
import React from 'react'

const ContainedButton = ({
  href = null,
  buttonCxNames,
  selected,
  title,
  iconName,
  hideIcon = false,
  isProxy = false
}) => {
  const Icon = SEARCH_TYPE_ICONS[iconName]

  return (
    <Button
      href={href}
      className={cx('w-100 h3 ma0 ph5 outline-0')}
      variant='contained'
      classes={{ root: buttonCxNames }}
      disabled={selected || isProxy}
    >
      <div className={cx('w-100 flex items-center justify-between', { white: selected }, { 'cadet-blue': !selected })}>
        <div>
          {title}
        </div>
        {Icon && !hideIcon && (
          <Icon className={cx('w6', { 'slate-grey': !selected })} />
        )}
      </div>
    </Button>
  )
}

const Button = styled(MuiButton)({
  height: '3rem',
  border: 'solid 1px #6288a5 !important',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'rgba(0,140,159,0.15)'
  }
})

export default ContainedButton
